"use strict";
(function (global) {

  /**
  * Редактор для компоненты slick-грида, для текстового реквизита
  * @see https://github.com/mleibman/SlickGrid/wiki/Writing-custom-cell-editors
  * @class WebAccess.components.dataViews.gridPlugins._editors.StringEditor
  * @extends BaseObject
  * @since 5.2.0.1300 
  */
  global.StringEditor = BaseObject.extend({
    id: null,
    renderState: null,

    _jContainer: null,
    _jInput: null,
    _column: null,
    _row: null,
    _gridComp: null,

    _value: null,
    _displayValue: null,
    _data: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function (args) {
      var me = this;

      ContextMenu.hideAll()

      me._super(args);
      me.renderState = $.Deferred();
      me.id = generateUniqueID();
      me._gridComp = args.grid;
      me._column = args.column;
      me._row = args.item;


      me.commit = args.commitChanges;
      me._value = me._row[me._column.id];
      // Чтобы 0 был нулём, а не пустым значением.
      if (me._value === null || _.isUndefined(me._value)) {
        me._value = '';
      }
      me._displayValue = me._row[me._column.field];
      if (me._displayValue === null || _.isUndefined(me._displayValue)) {
        me._displayValue = '';
      }

      me._jContainer = $(args.container);
      me._data = $.extend({}, me._column.requisite); //Копируем метаинформацию реквизита, т.к. копируется ссылка и изменение полей _data приводит к изменению _column.requisite, что нежелательно (#111079).

      me.render().done(function () {
        me._getWrapper().bind('change', function (e, i, values) {
          var last = me._value;
          var current = values.value;

          last = (last === null) ? "" : last;
          current = (current === null) ? "" : current;

          if (me.type === 'float' || me.type === 'integer') {
            last = +last;
            current = +current;
          } else {
            last = "" + last;
            current = "" + current;
          }

          if (last != current) {
            me._updateData(me._row, values);
          };
        });
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отрисовка реквизита, при активации редактора на ячейке грида
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#render
    * @since 5.2.0.1300     
    */
    render: function () {
      var me = this;

      var t = Hogan.compile('<div class="stringEditor editor"><input id="{{id}}" class="w100 input noBorder" value="{{value}}"/></div>');//FIXME: понятно же не так
      me._jContainer.html(t.render({
        id: me.id,
        value: me._getValueForRender()
      }));

      me._jInput = $('#' + me.id);

      // Для планшетов и сматфонов отключаем клавиатурную навигацию.
      if (!WA.ENV.isTouch()) {
        me.initKeyNavigation();
      }

      return me.renderState.resolve();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает значение реквизита для рендеринга редактора.
    * @private
    */
    _getValueForRender: function () {
      return this._displayValue;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Инициализация событий отвечающих за клавиатурную навигацию по ячейке
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#initKeyNavigation
    * @since 5.2.0.1300     
    */
    initKeyNavigation: function () {
      var me = this;
      var attempts = 0;
      var lastKey = null;

      // функция для читабельности кода
      var leaveOut = function (e) { };

      // функция для читабельности кода
      var stayHere = function (e) { e.stopImmediatePropagation(); };

      var isAllTextSelected = function (jInput) {
        var range = jInput.range();
        return (range.end - range.start === range.length && range.length);
      };

      var hasText = function (jInput) {
        return !!jInput.val();
      };

      me._jInput.bind("keydown.nav", function (e) {
        var key = e.keyCode;
        var jInput = $(this);
        var c = $.ui.keyCode;

        if (key === c.ENTER) {
          var _isAllTextSelected = isAllTextSelected(jInput);
          setTimeout(function () { // что бы дробное число выделялось при нажатии на Enter.
            if (_isAllTextSelected) {
              jInput.caret(0);
            } else {
              jInput.focus().select();
            }
          }, 100);
          e.stopImmediatePropagation();
        }

        if (key === c.ESCAPE) {
          jInput.focus().select();
          e.stopImmediatePropagation();
        }

        if (key === c.DOWN || key === c.UP) {
          me._handleUpDownKey(e);
        }

        if ((key === c.LEFT || key === c.RIGHT) && !e.shiftKey && !e.altKey && !e.metaKey && !e.ctrlKey) {
          if (isAllTextSelected(jInput) || !hasText(jInput)) {
            leaveOut(e);
          } else {
            if (jInput.caret() === jInput.val().length && key === c.RIGHT) {
              return leaveOut(e);
            }
            if (jInput.caret() === 0 && key === c.LEFT) {
              return leaveOut(e);
            }
            stayHere(e);
          }
        }
      }).focus();

      setTimeout(function () { // Без setTimeout не выделяется дробное число из-за плагина autoNumeric
        me._jInput.range(0, me._jInput.val().length); //Выделить текст
      });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _handleUpDownKey: function (e) {
      var key = e.keyCode;
      var c = $.ui.keyCode;

      if (key === c.DOWN) {
        // чтобы не добавлялось бесконечное число строк при нажатии вниз(изза 
        // change, который срабатывает в focusout)       
        this._jInput.off('focusout.autoNumeric').blur();
      } else {
        // чтобы не удалялась добавленная строка со значением
        this._jInput.blur();
      }

      //Чтобы не скролился документ
      e.preventDefault();
    },

    /**
    * Установить фокус на поле ввода
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#focus
    * @since 5.2.0.1300     
    */
    focus: function () {
      this._jInput.focus();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить объект-обертку над контролом реквизита, с необходимыми методами типа getValue;
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#_getWrapper
    */
    _getWrapper: function () {
      var me = this;
      if (!!me._wrapper) return me._wrapper;

      var parentCurrent = {
        _current: me._gridComp._parent.settings.current
      };

      var data = {
        controls: [me.id],
        displayValue: "",
        isRequired: false,
        isVisible: true,
        isReadOnly: false,
        value: "",
        row_id: me._row.id,
        sectionNumber: me._gridComp._parent.settings.sectionNumber,
        hasCalculation: me._column.hasCalculation
      };

      return me._wrapper = new WA.CMP.wrappers.form.requisites.Text(me._column.id, data, parentCurrent.form);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Признак того что значение в ячейке изменилось
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#isValueChanged
    * @since 5.2.0.1300     
    */
    isValueChanged: function () {
      var me = this;
      var newValue = me.serializeValue();

      if (newValue.value != me._value) {
        me._value = newValue.value;
        return true;
      }
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Применить существующее значение к гриду
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#applyValue
    * @since 5.2.0.1300     
    */
    applyValue: function (row, newData) {
      var me = this;

      me._updateData(row, newData);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _updateData: function (row, newData) {
      var me = this;
      row[me._column.id] = newData.value;
      row[me._column.field] = newData.displayValue;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @stub
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#loadValue
    * @since 5.2.0.1300     
    */
    loadValue: function () {
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получение значение из реквизита
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#serializeValue
    * @since 5.2.0.1300     
    */
    serializeValue: function () {
      var me = this;
      var control = me._getWrapper();
      var value = control.getValue();
      return { value: value, displayValue: value };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @stub
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#validate
    * @since 5.2.0.1300     
    */
    validate: function () {
      return { valid: true, msg: null };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Очистка поля
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#destroy
    * @since 5.2.0.1300     
    */
    destroy: function () {
      var me = this;
      me._updateData(me._row, me.serializeValue());
      me._jContainer.empty();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#disable
    * @since 5.2.0.1300     
    */
    disable: function () {
      this._getWrapper().disable();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#enable
    * @since 5.2.0.1300     
    */
    enable: function () {
      this._getWrapper().enable();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проброшенный метод из клиентской ОМ
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#setCustomAction
    * @since 5.2.0.1300     
    */
    setCustomAction: function (callback, opt_tooltip) {
      this._getWrapper().setCustomAction(callback, opt_tooltip);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить связанную с текущим реквизитом колонку.
    * @method WebAccess.components.dataViews.gridPlugins._editors.StringEditor#_getColumn
    * @private
    * @since 5.5.0.2703
    * @return {object} Колонка, связанная с реквизитом строки детального раздела.
    */
    _getColumn: function () {
      var me = this;
      var currentTable = me._gridComp._parent.getTable();
      return currentTable.columns[me._column.id];
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  });

})(window.WA.components.dataViews.gridPlugins._editors)